<script>
  function collapse(event) {
    var element = event.currentTarget;
    var target = element.parentNode;
    if (target.classList.contains("hide")) {
      target.classList.remove("hide");
    } else {
      target.classList.add("hide");
    }
    var content = element.nextElementSibling;
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
    } else {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  }
</script>

<style>
  .ico {
    display: inline-block;
    vertical-align: middle;
  }

  .collapse-header {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-top: 1rem;
    padding-bottom: 1rem;
    cursor: pointer;
  }

  .collapse-header-text {
    display: inline-block;
    font-weight: 600;
  }

  .collapse-header-ico {
    margin-left: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .collapse:not(.hide) .down {
    display: none;
  }

  .collapse.hide .up {
    display: none;
  }

  .collapse-body {
    padding-left: 1rem;
    padding-right: 1rem;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.35s ease;
  }
</style>

<div class="collapse hide">
  <div on:click={collapse} class="collapse-header flex jc-between">
    <div class="collapse-header-text">
      <slot name="header" />
    </div>
    <div class="collapse-header-ico">
      <svg
        width="1rem"
        height="1rem"
        viewBox="0 0 16 16"
        class="ico down"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          d="M1.553 6.776a.5.5 0 0 1 .67-.223L8 9.44l5.776-2.888a.5.5 0 1 1 .448.894l-6 3a.5.5 0 0 1-.448 0l-6-3a.5.5 0 0 1-.223-.67z" />
      </svg>
      <svg
        width="1rem"
        height="1rem"
        viewBox="0 0 16 16"
        class="ico up"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          d="M7.776 5.553a.5.5 0 0 1 .448 0l6 3a.5.5 0 1 1-.448.894L8 6.56 2.224 9.447a.5.5 0 1 1-.448-.894l6-3z" />
      </svg>
    </div>
  </div>
  <div class="collapse-body">
    <slot name="body" />
  </div>
</div>
